var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockNewIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28324 6.44772C9.75135 5.96804 10.5579 5.5 12 5.5C13.4422 5.5 14.2487 5.96804 14.7168 6.44772C15.1102 6.85081 15.3183 7.3913 15.4186 8.07559C15.5061 8.67246 15.5036 9.30603 15.5009 9.98461V9.98462C15.5009 9.98975 15.5009 9.99487 15.5009 10H8.49915C8.49913 9.99491 8.49911 9.98983 8.49909 9.98475L8.49909 9.98463C8.49643 9.30604 8.49396 8.67247 8.58142 8.07559C8.6817 7.3913 8.88987 6.85081 9.28324 6.44772ZM6.99888 10C6.99566 9.33021 6.99262 8.57227 7.09727 7.8581C7.22263 7.00264 7.51269 6.11434 8.20971 5.40009C8.98526 4.60536 10.1912 4 12 4C13.8088 4 15.0148 4.60536 15.7903 5.40009C16.4873 6.11434 16.7774 7.00264 16.9028 7.8581C17.0074 8.57228 17.0044 9.33021 17.0011 10H17.25C18.2165 10 19 10.7835 19 11.75V17.25C19 18.7688 17.7688 20 16.25 20H7.75C6.23122 20 5 18.7688 5 17.25V11.75C5 10.7835 5.7835 10 6.75 10H6.99888ZM6.5 11.75C6.5 11.6119 6.61193 11.5 6.75 11.5H17.25C17.3881 11.5 17.5 11.6119 17.5 11.75V17.25C17.5 17.9404 16.9404 18.5 16.25 18.5H7.75C7.05964 18.5 6.5 17.9404 6.5 17.25V11.75Z",
    fill: "#878F99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockNewIcon);
export default __webpack_public_path__ + "static/media/lockNewIcon.d3cc3a682c3a6e616e73996f1b1ad6a3.svg";
export { ForwardRef as ReactComponent };